<template>
  <footer>
    <div class="info">
       <div class="info-link pull-left" @click="goAbout">關於我們</div>
      <div class="pull-left"> |</div>
      <div class="info-link pull-left">常見問題</div>
      <div class="pull-left"> |</div>
      <div class="info-link pull-left" @click="goProduct">產品方案</div>
      <div class="clearfix"></div>
      <div class="info-link pull-left" @click="goService">服務條款</div>
      <div class="pull-left"> |</div>
      <div class="info-link pull-left" @click="goPrivacy">隱私條款</div>
      <div class="clearfix"></div>
    </div>
    <div class="bot">
      <div class="icon">
        <i
          class="fab fa-facebook-square"
          @click="openPage('https://www.facebook.com/papayum.cc')"
        ></i>
        <!-- <i class="fab fa-instagram"></i>
        <i class="fab fa-twitter-square"></i>
        <i class="fab fa-linkedin"></i> -->
      </div>
      <div class="text-center">
        連絡信箱：papayum.service@gmail.com
      </div>
      <div class="pull-left">
        <i class="far fa-copyright"></i> 2019 Papayum Inc.
      </div>
      <div class="clearfix"></div>

    </div>

  </footer>
</template>

<script>
export default {
  name: 'customer-footer',
  methods: {
    goAbout () {
      this.$router.push('/about')
    },
    goService () {
      this.$router.push('/services/terms')
    },
    goPrivacy () {
      this.$router.push('/privacy/policy')
    },
    goProduct () {
      this.$router.push('/product')
    },
    openPage (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
footer {
  text-align: center;
  .info {
    display: inline-block;
    color: #a39e9e;
    cursor: pointer;
    div {
      margin: 0 5px;
    }
  }
  .bot {
    color: #a39e9e;
    .icon {
      i {
        margin: 0 5px;
        cursor: pointer;
      }
      color: #f0a446;
      font-size: 24px;
      margin: 5px 0;
    }
  }

  font-size: 0.8rem;
  span {
    padding: 0 5px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/Footer.vue